import Vue from "vue";
import Vuex from "vuex";
import character from "@/store/character";
import adventure from "@/store/adventure";
import {
  getAdventurers,
  postAcceptInvite,
  postDeclineInvite,
} from "@/common/adventure/adventureInvite";

Vue.use(Vuex);

export default new Vuex.Store({
  // This must absolutely be disabled for production as it destroys performance
  // We keep it enabled in dev so we can detect bad mutations
  strict: true,
  modules: { character, adventure },
  state: {
    userId: "",
    username: "",
    password: "",
    email: "",
    characters: undefined,
    authToken: undefined, // If we have an auth token, we are logged in. It will be deleted if we detect we have been signed out
    adventures: undefined,
    currentAdventure: undefined,
    invites: [],
    adventureCharacters: undefined,
  },
  getters: {
    username: (state) => {
      return state.username;
    },
    userId: (state) => {
      return state.userId;
    },
    email: (state) => {
      return state.email;
    },
    characters: (state) => {
      return state.characters;
    },
    authToken: (state) => {
      return state.authToken;
    },
    adventures: (state) => {
      return state.adventures;
    },
    currentAdventures: (state) => {
      return state.currentAdventure;
    },
    invites: (state) => {
      return state.invites;
    },
    adventureCharacters: (state) => {
      return state.adventureCharacters;
    },
  },
  mutations: {
    setUsername: (state, newData) => {
      state.username = newData;
    },
    setUserId: (state, newData) => {
      state.userId = newData;
    },
    setEmail: (state, newData) => {
      state.email = newData;
    },
    setPassword: (state, newData) => {
      state.password = newData;
    },
    setCharacters: (state, newData) => {
      state.characters = newData;
    },
    setAuthToken: (state, newData) => {
      state.authToken = newData;
    },
    setAdventures: (state, newData) => {
      state.adventures = newData;
    },
    setCurrentAdventure: (state, newData) => {
      state.currentAdventure = newData;
    },
    setInvites: (state, newData) => {
      state.invites = newData;
    },
    removeFirstInvite: (state) => {
      state.invites.shift();
    },
    setAdventureCharacters: (state, newData) => {
      state.adventureCharacters = newData;
    },
  },
  actions: {
    declineInvite: (context: any, id: number) => {
      context.commit("removeFirstInvite");
      postDeclineInvite(id);
    },
    acceptInvite: (
      context: any,
      newData: { id: number; character_id: number }
    ) => {
      context.commit("removeFirstInvite");
      postAcceptInvite(newData.id, newData.character_id);
    },
    getAdventureCharacters: (context: any, adventure_id: number) => {
      getAdventurers(adventure_id).then((response) => {
        const ret = [];
        for (const c of response.data) {
          ret.push(c.characterId);
        }
        context.commit("setAdventureCharacters", ret);
      });
    },
  },
});
